const suggestionList = {
    path: '/',
    component: resolve => require(['@/pages/admin/suggestion/list.vue'], resolve)
}

export default suggestionList